import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { GuestReservationVerificationResultStatus } from '../../ReservationDetailConstants';
import { getVerificationStatusPillColor } from '../../../reservation-detail/ReservationHelper';
import { VerificationResultDetail } from '../../../../guests/models/GuestDetails';

@Component({
  selector: 'app-reservation-detail-verification-status-row',
  templateUrl: './reservation-detail-verification-status-row.component.html',
  styleUrls: ['./reservation-detail-verification-status-row.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatIcon
  ]
})
export class ReservationDetailVerificationStatusRowComponent {

  //PROCCESSING, CAUTION (FAILED), ERROR, NO VERIFICATION, PASSED

  @Input() statusText!: string;
  @Input() verificationResult?: VerificationResultDetail;
  getVerificationStatusTextColor = getVerificationStatusPillColor;

  getIcon(): string {
    switch (this.verificationResult?.check_result) {
      case GuestReservationVerificationResultStatus.PROCESSING:
        return 'autorenew';
      case GuestReservationVerificationResultStatus.CAUTION:
      case GuestReservationVerificationResultStatus.ERROR:
        return 'report';
      case GuestReservationVerificationResultStatus.NO_VERIFICATION:
        return 'more_horiz';
      case GuestReservationVerificationResultStatus.PASSED:
        return 'check_circle';
      default:
        return 'more_horiz';
    }
  }
}